var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#00AFEF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.353 23.05v7.009h-4.16v-6.54c0-1.643-.602-2.765-2.108-2.765-1.15 0-1.834.756-2.135 1.487-.11.261-.138.625-.138.99v6.828H19.65s.056-11.077 0-12.225h4.161v1.733l-.027.04h.027v-.04c.553-.832 1.54-2.02 3.75-2.02 2.74 0 4.792 1.747 4.792 5.502zM15.296 11.94c-1.424 0-2.355.912-2.355 2.112 0 1.173.905 2.113 2.3 2.113h.028c1.451 0 2.354-.94 2.354-2.113-.028-1.2-.903-2.112-2.327-2.112zM13.188 30.06h4.16V17.834h-4.16V30.06z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIcon);
export default __webpack_public_path__ + "static/media/linkedIcon.d98e0a72fd1cb94b32807631c7533169.svg";
export { ForwardRef as ReactComponent };